import { Key, useContext } from "react";
import { ISimpleTableField, ISimpleTableRow } from "./interface";
import styles from "./SimpleTableCell.module.css";
import { SimpleTableContext } from "./SimpleTableContext";
import { SimpleTableNullDate } from "./SimpleTableNullDate";

interface SimpleTableCellProps {
  rowId: Key;
  cellField: string;
  columnNumber: number;
  rowNumber: number;
}

export const SimpleTableCell = ({
  rowId,
  cellField,
  columnNumber,
  rowNumber,
}: SimpleTableCellProps): React.ReactElement => {
  const simpleTableContext = useContext(SimpleTableContext);

  const field: ISimpleTableField | undefined = simpleTableContext.fields.find(
    (f) => f.name === cellField,
  );

  const rowData: ISimpleTableRow | undefined = simpleTableContext.viewData.find(
    (d) => d[simpleTableContext.keyField] === rowId,
  );

  return (
    <td
      id={`${simpleTableContext.id}-row-${String(rowId).toLowerCase().trim()}-cell-${
        field?.name ?? columnNumber
      }`}
      key={cellField}
      className={styles.cell}
    >
      {!field || !rowData ? (
        `${!rowData ? "Row data" : ""}${!rowData && !field ? ", " : ""}${
          !field ? "Field" : ""
        } not found`
      ) : field.renderFn ? (
        field.renderFn({ rowData, columnNumber, field, cellField: field.name, rowNumber })
      ) : (
        <SimpleTableNullDate
          rowData={rowData}
          columnNumber={columnNumber}
          field={field}
          cellField={field.name}
          rowNumber={rowNumber}
        />
      )}
    </td>
  );
};

SimpleTableCell.displayName = "SimpleTableCell";
